import React from 'react';
import styles from './notFound.module.scss';
import { ReactComponent as NotFound } from 'assets/404.svg';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useAuth } from 'src/context/auth-context';



export const NotFoundPage = () => {
    const history = useHistory();
    const auth = useAuth();


    const handleClick = () => {
        auth.handleError(null);
        history.push('/dashboard');
    }
    return (
        <div className={styles['container']}>
            <div className={styles['container__icon']}><NotFound /></div>
            <div className={styles['container__title']}>PAGE NOT FOUND</div>
            <div className={styles['container__secondary']}>The page you're looking is not available</div>
            <div className={styles['container__secondary']}>Please refer to your system administrator</div>

            <div className={styles['container__button']}>
                <Button color="primary" variant="contained" onClick={handleClick}>Go back to homepage</Button>
            </div>
        </div>
    )
}